<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <div *ngIf="currentPerson">
                <form>
                    <div class="flex-direction-horizontal">
                        <div class="flex-container-basic">
                            <app-image srcPath="{{ currentPerson.AvatarBlobPath }}" isApiImage="true" className="app-image-medium app-image-circle"></app-image>
                        </div>
                        <div class="flex-direction-vertical flex-container-basic">
                            <mat-form-field appearance="outline">
                                <mat-label>First Name</mat-label>
                                <input *ngIf="currentPerson" matInput name="FirstName" placeholder="First Name" [(ngModel)]="currentPerson.FirstName" />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Last Name</mat-label>
                                <input *ngIf="currentPerson" matInput name="LastName" placeholder="Last Name" [(ngModel)]="currentPerson.LastName" />
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
        </mat-card-header>
        <mat-card-content>
            <br />
            <br />
            <div class="container">
                <div>
                    <!-- class="left" style="display:inline-table"> -->
                    <mat-card class="login-component">
                        <mat-card-header class="login-header">
                            <mat-card-title class="mat-card-title">PREFERENCES</mat-card-title>
                            <mat-card-subtitle class="mat-card-subtitle">Manage your site preferences</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <app-person-preferences #personPreferences [personEnvelope]="personEnvelope"></app-person-preferences>
                        </mat-card-content>
                    </mat-card>
                    <br />
                    <br />
                    <mat-card class="login-component">
                        <mat-card-header class="login-header">
                            <mat-card-title class="mat-card-title">ORGANIZATIONS</mat-card-title>
                            <mat-card-subtitle class="mat-card-subtitle">Control which organizations you work for</mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <app-chip-selector #organizationalUnitChipSelector label="Organizations" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableOrganizationalUnits" [value]="selectedOrganizationalUnitIds"></app-chip-selector>
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="login-component">
                        <mat-card-header class="login-header">
                            <mat-card-title class="mat-card-title">ACTIVITY</mat-card-title>
                            <mat-card-subtitle class="mat-card-subtitle"></mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <app-heat-map></app-heat-map>
                        </mat-card-content>
                        <mat-card-footer class="login-footer">

                        </mat-card-footer>
                    </mat-card>
                </div>
                <!--<div class="right">
                    <div>
                        <div class="widget-container">
                            <mat-card class="login-component">
                            </mat-card>
                        </div>
                        <div class="widget-container">
                        </div>
                    </div>
                </div>-->
            </div>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

